/*!
* name ZJX 个人信息
* Copyright 2018-2019
*/
<template>
  <div class="information_box">
    <publicNav></publicNav>
    <div v-if="isShow == 1">
      <div v-if="isVerified == 1 && isShow == 1">
        <img
          @click="modifyTeacherInformation"
          class="information_modify"
          src="../../assets/images/Modify.png"
          alt>
        <span @click="modifyTeacherInformation" class="information_ws">{{isCol == 3 ? '编辑信息' : '个人认证'}}</span>
      </div>
      <div v-if="isShow == 2">
        <img
          @click="modifyTeacherInformation"
          class="information_modify information_modify1"
          src="../../assets/images/Modify.png"
          alt
        >
        <span @click="modifyTeacherInformation" class="information_ws">个人信息编辑</span>
      </div>
    </div>
    <div v-if="isShow == 2">
      <div>
        <img style="right: 100px;"
             @click="modifyTeacherInformation"
             class="information_modify information_modify1"
             src="../../assets/images/Modify.png"
             alt>
        <span @click="modifyTeacherInformation"
              class="information_ws">{{ruleForm.phone == null ? '个人信息编辑' : '个人信息编辑'}} </span>
      </div>
    </div>
    <div v-show="tps" v-if="isShow == 2 && ruleForm.phone==null" class="information_modify_tlp">同学请先完善个人信息哦！</div>
    <!-- 老师个人信息S -->
    <div class="information_content" v-if="isVerified == 1 && isKen == 1">
      <ul class="information_content_ul">
        <li>
          <img :src="teacherData.avatar" alt>
          <span class="certificate_state" v-if="teacherData.certificate_state===3">已认证</span>
          <img class="gender" v-if="teacherData.gender"
               :src="teacherData.gender===1 ? require('../../assets/images/boy_icon@2x.png') : require('../../assets/images/girl_icon@2x.png')">
        </li>
        <li>
          <div class="information_name">
            <!--<span>v</span>-->
            <span>{{teacherData.name}}</span>
            <span>{{type_id == 1 ? '老师' :'学生'}}</span>
          </div>
          <div class="information_uesr">
            <ul class="information_uesr_ul">
              <li>
                <span>年龄</span>&nbsp;&nbsp;
                <span>{{teacherData.age}}岁</span>
              </li>
              <li>
                <span>联系电话</span>&nbsp;&nbsp;
                <span>{{teacherData.phone}}</span>
              </li>
              <li>
                <span>学校</span>&nbsp;&nbsp;
                <span>{{teacherData.school == null ? '' : teacherData.school.name}}</span>
              </li>
              <li v-if="type_id===1">
                <span>学科</span>&nbsp;&nbsp;
                <span>{{teacherData.subject}}</span>
              </li>
              <li class="beGood" v-if="type_id===1">
                <span>擅长</span>&nbsp;&nbsp;
                <span>{{teacherData.adept}}</span>
              </li>
              <li v-if="type_id===2">
                <span>学号</span>&nbsp;&nbsp;
                <span>{{teacherData.student_number}}</span>
              </li>
              <li v-if="type_id===2">
                <span>兴趣</span>&nbsp;&nbsp;
                <span>{{teacherData.interest}}</span>
              </li>
              <li v-if="type_id===2">
                <span>年级班级</span>&nbsp;&nbsp;
                <span>{{teacherData.school_level}}年级 {{teacherData.school_grade_class}}班级</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="isVerified == 1 && tpls == '教师'" class="information_modify_tlp">
      <span class="content">{{textTpl}}</span>
      <span class="reason" v-if="state==4">原因：{{remark||''}}</span>
    </div>
    <!-- 老师个人信息E -->
    <!-- 编辑老师信息S -->
    <div class=" information_modify_teacher" v-if="isHide">
      <div class="information_modify_header">
        <el-upload
          class="avatar-uploader"
          :action="teacherUrlData"
          :headers="token"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          name="avatar"
          type="file"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="information_modify_form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="98px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="userName">
            <el-input v-model="ruleForm.userName" placeholder="请输入姓名" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入联系方式" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="resource">
            <el-radio-group v-model="ruleForm.resource">
              <el-radio label="男性"></el-radio>
              <el-radio label="女性"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年龄" prop="age">
            <el-input v-model="ruleForm.age" placeholder="请输入年龄" maxlength="3"></el-input>
          </el-form-item>
          <el-form-item label="学校" prop="region">
            <el-select v-model="ruleForm.region" placeholder="请选择学校">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级班级" required v-if="isShow == 2">
            <el-col :span="11">
              <el-form-item prop="date1">
                <el-input v-model="ruleForm.date1" placeholder="请填写年级" maxlength="3"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-input v-model="ruleForm.date2" placeholder="请填写班级" maxlength="3"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="学号" prop="xuehao" v-if="isShow == 2">
            <el-input v-model="ruleForm.xuehao" placeholder="请填写学号" maxlength="5"></el-input>
          </el-form-item>
          <el-form-item label="兴趣" prop="xingqu" v-if="isShow ==2">
            <el-input v-model="ruleForm.xingqu" placeholder="请填写兴趣" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="学科" prop="subject" v-if="isShow == 1">
            <el-input v-model="ruleForm.subject" placeholder="请输入学科" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="擅长" prop="beGood" v-if="isShow == 1">
            <el-input v-model="ruleForm.beGood" placeholder="请输入擅长" maxlength="30"></el-input>
          </el-form-item>
        </el-form>
        <div class="information_btn" v-if="isShow == 2">
          <el-button
            type="primary"
            size="medium"
            class="information_modify_btn"
            @click="submitForm('ruleForm')"
          >提交
          </el-button>
        </div>
      </div>
    </div>
    <!--<input type="file" id="aaa">-->
    <div class="information_upload_qualification" v-if="isHide && isShow == 1">
      <div class="information_text" v-if="isCol!=3">
        <span>资质证书</span>
        <span>(可以不上传附件就提交审核)</span>
      </div>
      <div class="information_up" v-if="isCol!=3">
        <el-upload :file-list="fileList2"
                   :action="qualificationsTeacherUrlData"
                   list-type="picture-card"
                   :on-preview="handlePictureCardPreview"
                   :on-remove="handleRemove"
                   :headers="token"
                   :before-upload="beforeAvatar"
                   name="img"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt>
        </el-dialog>
      </div>
      <div class="information_btn">
        <el-button
          type="primary"
          size="medium"
          class="information_modify_btn"
          @click="submitForm('ruleForm')"
        >提交
        </el-button>
      </div>
    </div>
    <!-- 编辑老师信息E -->
  </div>
</template>

<script>
import publicNav from '@/components/publicnav' // 引入公共页签
import cacheUtils from '@/common/cacheUtils' // 调用缓存
import apiInterface from '@/api/index' // 接口
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      imageUrl: '',
      fileList2: [],
      ruleForm: {
        userName: '', // 姓名验证
        phone: '', // 联系电话
        age: '', // 年龄
        subject: '', // 学科
        beGood: '', // 擅长
        region: '', // 学校
        resource: '', // 性别
        date1: '', // 学校
        date2: '', // 班级
        xuehao: '', // 学校
        xingqu: '', // 兴趣
        avatar: '' // 头像图片路径
      },
      isKen: '',
      textTpl: '您还未进行教师身份认证，快去认证吧！',
      teacherUrlData: apiInterface.avatarUpload, // 个人头像上传接口
      qualificationsTeacherUrlData: apiInterface.certificateUpload, // 个人头像上传接口
      token: { Authorization: 'Bearer' + cacheUtils.cookie.getObject('Token') },
      // 验证内容
      rules: {
        userName: [
          {
            required: true,
            message: '支持汉字,字母,需要跟证件中名称一致',
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '支持11位数字', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入11位手机号', trigger: 'blur' }
        ],
        age: [
          { required: true, message: '支持数字', trigger: 'blur' },
          { min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur' }
        ],
        subject: [
          { required: true, message: '支持数字、汉字', trigger: 'blur' },
          { min: 0, max: 100, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        beGood: [
          { required: true, message: '支持数字、汉字', trigger: 'blur' },
          { min: 0, max: 100, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        region: [{ required: true, message: '请选择学校', trigger: 'change' }],
        resource: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        date1: [{ required: true, message: '请填写学校', trigger: 'change' }],
        date2: [{ required: true, message: '请填写班级', trigger: 'change' }],
        xuehao: [{ required: true, message: '支持数字', trigger: 'change' }],
        xingqu: [
          { required: true, message: '支持数字、汉字', trigger: 'change' }
        ]
      },
      dialogImageUrl: '',
      dialogVisible: false,
      intTeacherShow: '', // 初始化显示老师个人信息
      teacherData: {
        // 老师个人信息
        avatar: '', // 头像
        age: '', // 年龄
        name: '', // 姓名
        phone: '', // 手机号
        subject: '', // 学科
        gender: '',
        adept: '' // 擅长
      },
      type_id: '',
      isVerified: null, // 判断是否验证
      isHide: false,
      urlPdata: {
        avatar: ''
      },
      options: [], // 学校列表
      tpls: '',
      isShow: cacheUtils.sessionStorage('status').get('zjx'),
      isCol: '',
      tps: true,
      remark: '',
      state: '',
      gender: ''
    }
  },
  computed: {},
  components: {
    publicNav
  },
  mounted () {},
  methods: {
    ...mapMutations({
      curUserName: 'SET_USERNAME',
      curAvatar: 'SET_AVATAR'
    }),
    // 修改师资资料
    modifyTeacherInformation () {
      if (this.state === 2) {
        this.$message.warning('个人资料正在审核中，请耐心等待')
        return
      }
      this.isHide = true
      this.isVerified = 2
      this.tps = false
    },
    // 上传头像成功方法
    handleAvatarSuccess (res) {
      console.log('res:', res)
      this.imageUrl = res.data.avatar_url
      this.ruleForm.avatar = res.data.avatar_url
    },
    // 上传头像是否成功
    beforeAvatarUpload (file) {
      console.log(file)
      this.urlPdata.avatar = file.name
    },
    beforeAvatar (res, file) {
      console.log(res)
      console.log(file)
      const isLt2M = res.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    // 提交校验表单
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.teacherRenewal()
        } else {
          return false
        }
      })
    },
    handleRemove () {},
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 教师个人信息更新
    async teacherRenewal () {
      let regPos = /^\d+$/ // 非负整数
      let reg = /[~#^$@%&!?%*]/gi
      if (regPos.test(this.ruleForm.age)) {
      } else {
        this.$message.error('年龄必须为整数')
        return
      }
      if (reg.test(this.ruleForm.subject.trim())) {
        this.$message.error('学科不能包含特殊字符')
        return
      }
      if (reg.test(this.ruleForm.beGood.trim())) {
        this.$message.error('擅长不能包含特殊字符')
        return
      }
      try {
        let data = {}
        if (isNaN(this.ruleForm.region)) { // 说明是传参过来的~~~~
          this.options.map(item => {
            if (item.label == this.ruleForm.region) {
              this.ruleForm.region = item.value
            }
          })
        } else { // 自己选择的值
          this.ruleForm.region = this.ruleForm.region
        }
        if (this.isShow == 1) {
          data = {
            name: this.ruleForm.userName,
            phone: this.ruleForm.phone,
            gender: this.ruleForm.resource == '男性' ? 1 : 2,
            school_id: this.ruleForm.region,
            age: this.ruleForm.age,
            subject: this.ruleForm.subject,
            adept: this.ruleForm.beGood,
            avatar: this.imageUrl
          }
        } else {
          data = {
            name: this.ruleForm.userName,
            phone: this.ruleForm.phone,
            gender: this.ruleForm.resource == '男性' ? 1 : 2,
            school_id: this.ruleForm.region,
            age: this.ruleForm.age,
            school_level: this.ruleForm.date1,
            school_grade_class: this.ruleForm.date2,
            student_number: this.ruleForm.xuehao,
            interest: this.ruleForm.xingqu,
            avatar: this.imageUrl
          }
        }
        let pdata = await this.$xhr.post(
          this.isShow == 1
            ? apiInterface.teachersProfileUpdate
            : apiInterface.studentsProfileUpdate,
          data
        )
        this.curUserName(this.ruleForm.userName)
        this.curAvatar(this.imageUrl)
        if (this.type_id == 1) {
          let auditData = await this.$xhr.post(apiInterface.audit, {})
          console.log('教师提交审核 结果:', auditData)
        }
        this.$message.success('修改成功')
        if (pdata) {
          this.accessPersonalInformation()
          this.isHide = false
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 获取学校列表
    async getSchoolsList () {
      try {
        let pdata = await this.$xhr.get(apiInterface.schoolsList, {
          params: {}
        })
        if (pdata.data) {
          let arrList = []
          pdata.data.map(item => {
            let obj = {
              value: item.id,
              label: item.name
            }
            arrList.push(obj)
          })
          this.options = arrList
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    // 获取个人信息内容
    async accessPersonalInformation () {
      try {
        let pdata = await this.$xhr.get(apiInterface.userInfo, { params: {} })
        if ('teacher' in pdata.data) {
          this.teacherData = Object.assign(
            {},
            this.teacherData,
            pdata.data.teacher
          )
          this.imageUrl = this.teacherData.avatar
          this.ruleForm.userName = this.teacherData.name
          this.ruleForm.phone = this.teacherData.phone
          this.ruleForm.age = this.teacherData.age == null ? '' : this.teacherData.age.toString()
          this.ruleForm.subject = this.teacherData.subject
          this.ruleForm.beGood = this.teacherData.beGood
          this.ruleForm.region = this.teacherData.school == null ? '' : this.teacherData.school.name
          this.ruleForm.resource = this.teacherData.gender == 1 ? '男性' : '女性'
          this.ruleForm.beGood = this.teacherData.adept
          this.state = pdata.data.teacher.certificate_state
          this.gender = this.teacherData.gender
          if (pdata.data.teacher.certificate_img) {
            this.fileList2.push({ url: pdata.data.teacher.certificate_img })
          }
          this.type_id = pdata.data.type_id
          if (pdata.data.teacher.certificate_state == 1) {
            // 等于1是待认证1
            this.isVerified = 1
            this.tpls = '教师'
            this.textTpl = '您还未进行教师身份认证，快去认证吧！'
            if (pdata.data.teacher.name != null) {
              this.textTpl = '您已提交认证，请等待审核结果！'
              this.isKen = 1
            }
            this.isCol = pdata.data.teacher.certificate_state
          } else if (pdata.data.teacher.certificate_state == 4) {
            this.isVerified = 1
            this.tpls = '教师'
            this.textTpl = '您审核未通过请重新认证！'
            this.remark = pdata.data.teacher.certificate_remark || ''
            if (pdata.data.teacher.name != null) {
              this.textTpl = '您审核未通过请重新认证！'
              this.isKen = 1
            }
            this.isCol = pdata.data.teacher.certificate_state
          } else if (pdata.data.teacher.certificate_state == 3) {
            this.isVerified = 1
            this.tpls = '学生'
            this.isKen = 1
            this.isCol = pdata.data.teacher.certificate_state
            this.textTpl = '您已审核通过！'
            // this.isShow = 2;
          } else if (pdata.data.teacher.certificate_state == 2) {
            this.isVerified = 1
            this.tpls = '教师'
            this.textTpl = '您已提交认证，请等待审核结果！'
            if (pdata.data.teacher.name != null) {
              this.textTpl = '您已提交认证，请等待审核结果！'
              this.isKen = 1
            }
            this.isCol = pdata.data.teacher.certificate_state
          }
        } else {
          this.teacherData = Object.assign(
            {},
            this.teacherData,
            pdata.data.student
          )
          this.type_id = pdata.data.type_id
          if (this.teacherData.phone != null) {
            this.isKen = 1
            this.isVerified = 1
          }
          this.imageUrl = this.teacherData.avatar
          this.ruleForm.userName = this.teacherData.name
          this.ruleForm.phone = this.teacherData.phone
          this.ruleForm.age = this.teacherData.age == null ? '' : this.teacherData.age.toString()
          this.ruleForm.subject = this.teacherData.subject
          this.ruleForm.beGood = this.teacherData.beGood
          this.ruleForm.region = this.teacherData.school == null ? '' : this.teacherData.school.name
          this.ruleForm.resource = this.teacherData.gender == 1 ? '男性' : '女性'
          this.ruleForm.beGood = this.teacherData.adept
          this.ruleForm.date1 = this.teacherData.school_level
          this.ruleForm.date2 = this.teacherData.school_grade_class
          this.ruleForm.date2 = this.teacherData.school_grade_class
          this.ruleForm.xuehao = this.teacherData.student_number
          this.ruleForm.xingqu = this.teacherData.interest
        }
      } catch (error) {
        console.log(error)
        this.$message.error(error)
      }
    }
  },
  created () {
    this.accessPersonalInformation()
    this.getSchoolsList()
  }
}
</script>

<style lang="scss">
.information_box {
  position: relative;

  .information_modify {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 18px;
    right: 72px;
    cursor: pointer;
  }

  .information_modify1 {
    width: 18px;
    height: 18px;
    position: absolute;
    top: 18px;
    right: 98px;
    cursor: pointer;
  }

  .information_ws {
    color: #15c1e4;
    cursor: pointer;
    position: absolute;
    right: 0px;
    top: 17px;
    right: 10px;
  }
}

.information_content {
  width: 770px;
  overflow: hidden;

  .information_content_ul {
    width: 770px;
    height: 160px;

    li:nth-child(1) {
      width: 190px;
      height: 190px;
      float: left;
      position: relative;

      img {
        width: 120px;
        height: 120px;
        border-radius: 100%;
        float: left;
        margin-left: 30px;
        margin-top: 15px;
      }
    }

    .certificate_state {
      float: left;
      width: 100%;
      margin-top: 5px;
      text-align: center;
    }

    li:nth-child(2) {
      width: 580px;
      height: 160px;
      float: right;

      .information_name {
        width: 580px;
        height: 60px;
        box-sizing: border-box;
        padding-top: 30px;
        margin-bottom: 10px;

        span {
          font-size: 18px;
          font-weight: bold;
        }

        /*span:nth-child(1) {*/
        /*float: left;*/
        /*width: 20px;*/
        /*height: 20px;*/
        /*background: #15c1e4;*/
        /*color: #fff;*/
        /*font-weight: 100;*/
        /*text-align: center;*/
        /*line-height: 20px;*/
        /*border-radius: 50%;*/
        /*margin-top: 3px;*/
        /*}*/

        span:nth-child(2) {
          float: left;
          /*margin-left: 10px;*/
        }

        span:nth-child(3) {
          float: left;
          margin-left: 10px;
        }
      }

      .information_uesr {
        width: 580px;
        height: 100px;
        box-sizing: border-box;

        .information_uesr_ul {
          width: 580px;
          height: 100px;

          li {
            width: 150px;
            height: 40px;
            margin-bottom: 5px;
            /*line-height: 40px;*/
            float: left;
            font-size: 15px;
          }

          .beGood {
            width: 400px !important;
          }

          li:nth-child(1) {
            width: 130px;
          }

          li:nth-child(2) {
            width: 200px;
          }

          li:nth-child(3) {
            width: 200px;
          }

          li:nth-child(4) {
            width: 130px;
          }

          li:nth-child(5) {
            width: 400px;
          }

          li:nth-child(6) {
            width: 500px;
          }
        }
      }
    }

    .gender {
      width: 24px !important;
      height: 24px !important;
      position: absolute;
      bottom: 52px;
      right: 24px;
    }
  }
}

.information_modify_tlp {
  width: 770px;
  min-height: 150px;
  /*height: 150px;*/
  background: #f4f4f4;
  padding: 60px 0;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  text-align: center;
  font-size: 15px;
  color: #b5b5b5;
  margin-top: 12px;
  box-sizing: border-box;

  .content {
    width: 600px;
    margin: 0 auto;
    display: block;
  }

  .reason {
    width: 600px;
    margin: 0 auto;
    display: block;
  }
}

.information_modify_teacher {
  width: 770px;
  overflow: hidden;
  padding-bottom: 40px;
  box-sizing: border-box;
  padding-left: 210px;
  padding-right: 210px;

  .information_modify_header {
    height: 150px;
    box-sizing: border-box;
    padding-top: 20px;
    //上传头像图片样式 S
    .avatar-uploader {
      width: 120px;
      height: 120px;
      margin: 0 auto;
    }

    .avatar-uploader .el-upload {
      border: 1px solid #aaaaaa;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      border-radius: 50%;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
      border: 1px solid #aaaaaa;
      border-radius: 50%;
    }

    .avatar {
      width: 120px;
      height: 120px;
      display: block;
      border-radius: 50%;
    }

    //上传头像图片样式 E
  }

  .information_modify_form {
    box-sizing: border-box;
    margin-top: 20px;
  }
}

.information_modify_btn {
  width: 85%;
  margin-top: 50px;
  margin-left: 50px;
  background: #15c1e4;
  border: 1px solid #15c1e4;
  height: 47px;
}

.information_upload_qualification {
  border-top: 2px solid #f0f0f0;
  height: 350px;
  box-sizing: border-box;
  padding-top: 15px;

  .information_text {
    span:nth-child(2) {
      margin-left: 40px;
      color: #cbcbcb;
    }
  }

  .information_up {
    margin-top: 20px;
    box-sizing: border-box;
    padding-left: 100px;
  }

  .information_btn {
    box-sizing: border-box;
    padding-left: 200px;
    padding-right: 200px;
  }
}

.el-select {
  display: block;
  position: relative;
}

.el-upload-list--picture-card .el-upload-list__item {
  margin: 0px;
}
</style>

